import { render, staticRenderFns } from "./OrgCountByRegionAndTypeComponent.vue?vue&type=template&id=189caa52&scoped=true&"
import script from "./OrgCountByRegionAndTypeComponent.vue?vue&type=script&lang=js&"
export * from "./OrgCountByRegionAndTypeComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "189caa52",
  null
  
)

export default component.exports